import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  AfterViewInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';

@Directive({
  selector: '[lazyBackground]',
  standalone:false,
})
export class LazyBackgroundDirective implements AfterViewInit {
  @Input('lazyBackground') backgroundImage: string = ''
  isBrowser:boolean=false
	constructor(
		@Inject(PLATFORM_ID) private platformId: Object,
		private el: ElementRef, private renderer: Renderer2

	) { 
		this.isBrowser = isPlatformBrowser(this.platformId);
	}

  ngAfterViewInit() {
    if(!this.isBrowser) return 
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.renderer.setStyle(
            this.el.nativeElement,
            'background-image',
            `url(${this.backgroundImage})`
          );
          console.log(this.backgroundImage)
          observer.unobserve(this.el.nativeElement);
        }
      });
    });

    observer.observe(this.el.nativeElement);
  }
}
